module.exports = __webpack_public_path__ + "assets/img/33_719_big.02cb55ad.jpg";